import React, { useState } from 'react';

export default function SchoolLoginDesign2() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-purple-600 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-400 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
      <div className="absolute -bottom-8 left-20 w-96 h-96 bg-gold-300 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>

      <div className="w-full max-w-md relative z-10">
        {/* Card */}
        <div className="bg-white bg-opacity-95 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden border border-white border-opacity-20">
          {/* Header */}
          <div className="bg-gradient-to-r from-purple-700 to-purple-900 px-8 py-16 text-center relative">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-yellow-300 to-yellow-500 rounded-full flex items-center justify-center shadow-xl transform rotate-12">
                <span className="text-4xl">🎓</span>
              </div>
            </div>
            <h1 className="text-4xl font-black text-white mb-2">Academy Pro</h1>
            <p className="text-purple-200 text-lg font-light">Premium School Management</p>
          </div>

          {/* Form */}
          <div className="px-8 py-12 space-y-6">
            <div>
              <label className="block text-sm font-bold text-gray-800 mb-3 uppercase tracking-wider">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@school.com"
                className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:outline-none focus:border-purple-600 focus:ring-2 focus:ring-purple-300 transition bg-gray-50"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-800 mb-3 uppercase tracking-wider">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:outline-none focus:border-purple-600 focus:ring-2 focus:ring-purple-300 transition bg-gray-50"
              />
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                <input type="checkbox" className="w-4 h-4 rounded border-purple-300 text-purple-600" />
                Keep me signed in
              </label>
              <a href="#" className="text-sm text-purple-600 hover:text-purple-800 font-bold">Forgot Password?</a>
            </div>

            <button className="w-full bg-gradient-to-r from-purple-600 to-purple-800 text-white font-bold py-3 rounded-xl hover:shadow-2xl transition duration-300 transform hover:-translate-y-1 uppercase tracking-wide">
              Login Now
            </button>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">Need Help?</span>
              </div>
            </div>

            <p className="text-center text-sm text-gray-600">
              <span className="text-purple-600 font-bold cursor-pointer hover:text-purple-800">Contact Support</span>
            </p>
          </div>
        </div>

        <p className="text-center text-white text-xs mt-6 opacity-70">Secure Education Platform © 2024</p>
      </div>
    </div>
  );
}
